import React, {useState, useEffect} from 'react';
import Typography from '@material-ui/core/Typography';

export default function Intro (props) {

    
let whatIs = (
<React.Fragment> 
 <Typography variant="h6">
    What is Game For Crypto?
 </Typography>

<Typography variant="p">
    <p>Game For Crypto, GFC, is a platform developed to act as an online arcade, where gamers can win cryptocurrency based on gaming challenges.</p> 
 </Typography>

<Typography variant="p">
    <p>These challenges, also known as Contests, are created by gamers with the intention to be joined by other gamers. </p> 
 </Typography>
<Typography variant="p">
    <p>The first gamer to complete the conditions of the contest, or with the highest score at the end of the contest wins!  </p> 
 </Typography>

<Typography variant="p">
    <p>Each contest has an entry fee in Credits. Contest credits are claimed by the winner after completion of the contest. 
These credits are acquired by using the GFC front end, and cost .0001 ETH per credit.  </p> 
 </Typography>

<Typography variant="p">
    <p>Credits are stored on the GFC smart contract linked to Ethereum address / Gamer Name. Gamers can withdraw credits at anytime,
Which is returned as ETH to the gamers ETH wallet. </p> 
 </Typography>

</React.Fragment> 
); 

let gamingContests = (
<React.Fragment> 
 <Typography variant="h6">
    What are examples of Gaming Contests?
 </Typography>

<Typography variant="p">
    <p>GFC was developed quickly for the Chainlink Hackathon. It currently only has support for 2 games, Snake and Fortnite. </p> 
 </Typography>

<Typography variant="p">
    <p>Current contest win conditions include: </p> 
 </Typography>

<Typography variant="p">
    <p>Snake: High score after 3 rounds.  </p> 
 </Typography>

<Typography variant="p">
    <p>Fortnite: First to get 10 eliminations or First to get a Victory Royale. </p> 
 </Typography>

</React.Fragment> 
); 

let howTo = (
<React.Fragment> 
 <Typography variant="h6">
    How to use Game For Crypto?
 </Typography>

<Typography variant="p">
    <p>Currently, GFC is functional and in testing, deployed on the Kovan Ethereum Testnet. </p> 
 </Typography>

<Typography variant="p">
    <p>If you would like to participate, please follow these steps. </p> 
 </Typography>
<Typography variant="p">
    <p>1. Ensure metamask is installed as in extension on your browser. </p> 
 </Typography>

<Typography variant="p">
    <p>2. Open metamask, and ensure you are on the Kovan network. </p> 
 </Typography>

<Typography variant="p">
    <p>3. Click connect on the top right corner of the page, to request access / connect your wallet.</p> 
 </Typography>



 <Typography variant="p">
    <p>Note: This is your key to using GFC, and the only registration information needed. No email needed.</p> 
 </Typography>

 <Typography variant="p">
    <p>4. Pick a Gamer Name,  32 Characters or Less. No Spaces.</p> 
 </Typography>

  <Typography variant="p">
    <p>Optional: If you intend to play Fortnite contests, set your Fortnite name.</p> 
 </Typography>

  <Typography variant="p">
    <p>5. Choose an amount of credits to deposit. 10 min. Click insert credits.</p> 
 </Typography>

  <Typography variant="p">
    <p>Now with credits in your account, you can join contests, or even create your own. Win a few contests and withdraw your credits at anytime!</p> 
 </Typography>


  <Typography variant="p">
    <p>Have fun!</p> 
 </Typography>

</React.Fragment> 
); 


let whoMade = (
<React.Fragment> 
 <Typography variant="h6">
   Who Developed Game For Crypto and Why?
 </Typography>

<Typography variant="p">
    <p>GFC was developed by Geoff Kemper. I am a freelancer who specializes in Node, React, React Native, Firebase, AWS, and other less popular platforms. </p> 
 </Typography>

<Typography variant="p">
    <p>I am very interested in hearing about opportunities to work on projects involving blockchain and smart contracts.  </p> 
 </Typography>

 <Typography variant="p">
    <p>Through developing GFC, I have acquired a working knowledge of Smart Contracts, Solidity and Web3, along with integration in front end and back end systems. </p> 
 </Typography>

<Typography variant="p">
    <p>I am also very interested in continuing to build out GFC to be production ready at some point.  </p> 
 </Typography>

  <Typography variant="p">
    <p>If you are interested in helping as a team member or otherwise, please reach out, sincerely, Geoff Kemper. GameForCrypto@gmail.com  </p> 
 </Typography>

<Typography variant="p">
    <p>Important Note: This demonstration is running on Kovan Testnet only. GFC has no affiliation with Fortnite. All Fortnite data is provided by public APIs.  </p> 
 </Typography>

</React.Fragment> 
); 

let gfcParts = (
    <React.Fragment> 
 <Typography variant="h6">
   What Parts Make Up Game For Crypto?
 </Typography>

<Typography variant="p">
    <p>- Smart Contract: Developed utilizing Solidity, Chainlink API Oracle and Hardhat. </p> 
 </Typography>

<Typography variant="p">
    <p>- Front End : React Application developed to interface with the Game For Crypto smart contract. </p> 
 </Typography>

 <Typography variant="p">
    <p>- Back End: Node, Google Firebase / Firestore / Cloud Functions. Used to maintain a single source of truth and setup / maintain accurate interaction with the smart contract. 
Also Provides API connection for games to get and post contest gaming data. </p> 
 </Typography>

<Typography variant="p">
    <p>- Snake Example: Open source simple snake react example, with a simple integration with Game For Crypto. </p> 
 </Typography>

</React.Fragment> 
    






)


return (
    <React.Fragment>
    {whatIs}
    {gamingContests}
    {howTo}
    {whoMade}
    {gfcParts}
    </React.Fragment>
    )
}